import { useEffect, useMemo, useState } from 'react';
import { useLocation, useSearchParams, useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import Page from '../../components/Page';
import useSettings from '../../hooks/useSettings';
import { PATH_DASHBOARD } from '../../routes/paths';
import ManageUserProfileView from '../../sections/admin/ManageUserDialog/ManageUserProfileView';

const VALID_TABS = new Set([
  'profile',
  'transaction',
  'policy',
  'controls',
  'bank-accounts',
  'beneficiaries',
  'referrals',
  'invites',
  'security',
  'devices',
]);

function resolveTab(searchParams) {
  const tab = searchParams.get('tab');
  return VALID_TABS.has(tab) ? tab : 'profile';
}

export default function UserProfilePage() {
  const { themeStretch } = useSettings();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { userId } = useParams();
  const [profileName, setProfileName] = useState(location.state?.user?.display_name || 'User Profile');

  const currentTab = resolveTab(searchParams);
  const seededUser = useMemo(
    () => ({
      ...(location.state?.user || {}),
      user_id: userId,
    }),
    [location.state?.user, userId]
  );

  useEffect(() => {
    setProfileName(location.state?.user?.display_name || userId || 'User Profile');
  }, [location.state?.user?.display_name, userId]);

  return (
    <Page title={profileName}>
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <HeaderBreadcrumbs
          heading={profileName}
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Users', href: PATH_DASHBOARD.users.allUsers },
            { name: 'All users', href: PATH_DASHBOARD.users.allUsers },
            { name: userId || 'User profile' },
          ]}
        />

        <ManageUserProfileView
          currentTab={currentTab}
          onProfileNameChange={setProfileName}
          onTabChange={(event, nextTab) => {
            setSearchParams({ tab: nextTab });
          }}
          user={seededUser}
        />
      </Container>
    </Page>
  );
}
